module.exports = __webpack_public_path__ + "30e49f15ff41a007976edf3fbd60fc55.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/svgs/dotnetse_logo.svg
// module id = 2
// module chunks = 0